import { GoogleAuthProvider } from "firebase/auth";
import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthProvider";

const GoogleLogin = () => {
  const { loginProvider } = useContext(AuthContext);

  const GoogleProvider = new GoogleAuthProvider();

  const handleGoogleSignIn = () => {
    loginProvider(GoogleProvider)
      .then((data) => {
        console.log(data);
      })
      .catch((err) => console.log(err));
  };
  return (
    <button onClick={handleGoogleSignIn} className="btn btn-outline w-full">
      <p>Continue with Google</p>
    </button>
  );
};

export default GoogleLogin;
